import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decimalToPercents',
    standalone: false
})
export class DecimalToPercentsPipe implements PipeTransform {

  transform(value: number): string {
    const percentage = Math.round(value * 100);
    return `${percentage}%`;
  }

}
